<template>
    <div>
      <template v-if="getLawlexLoadingStatus">
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
      </template>
      <template v-else>
        <template v-if="hasErrorCode">
            <UserNotRegistered :type="accessType"/>
        </template>
        <template v-else-if="accordionData && accordionData.length > 0">
            <div class="lawlex-accordion-container">
                    <div class="compact-content-container-wrapper">
                    <div
                    v-for="(item, index) in getLimitedContent(content.title, accordionData)"
                    :key="item.targetUrl || index"
                    class="compact-content-container"
                    >
                        <div v-if="item && item.title">
                            <span class="title-container">
                              <img :src="getImageSrc()"/>
                              <a href="javascript:void(0)" @click="clickUrl(item.targetUrl)">{{ truncateEnd(item.title) }}</a>
                            </span>
                            <span class="date">{{ item.date }}</span>
                        </div>
                    </div>
                    <!-- See More Link -->
                    <a v-if="seeMoreUrl" href="javascript:void(0)" @click="clickUrl(seeMoreUrl)" class="see-more">
                        See more
                    </a>
                </div>
            </div>
        </template>
        <template v-else-if="noAccessCondition">
          <NoAccess :type="accessType" />
        </template>
        <template v-else-if="hasErrorCodeUserNotActive">
          <NoDataOrUserNotActive
          :isUserNotActive="true"
          :title="$t('msg_user_not_active')"
          :imageSrc="lawlexUserIcon"
        />
        </template>
        <template v-else-if="hasErrorCodeTypeOtherErrors">
          <SomethingWentWrong />
        </template>
        <template v-else>
          <NoDataOrUserNotActive
          :isUserNotActive="false"
          :title="noDataMessage"
          :imageSrc="lawlexNoDataIcon"
        />
        </template>
    </template>
  </div>
</template>


  <script>
  import UserNotRegistered from "@/components/QuickViews/AccordionContent/Lawlex/UserNotRegistered";
  import NoAccess from "@/components/QuickViews/AccordionContent/Lawlex/NoAccess.vue";
  import SomethingWentWrong from "@/components/QuickViews/AccordionContent/Lawlex/SomethingWentWrong.vue";
  import NoDataOrUserNotActive from "@/components/QuickViews/AccordionContent/Lawlex/NoDataOrUserNotActive";
  import { createNamespacedHelpers } from "vuex";
  import eurlexSavedSearchIcon from "@/img/eurlex-saved-search-icon.svg";
  import lawlexNoDataIcon from "@/img/lawlex-no-data.svg";
  import lawlexRecentSearchIcon from "@/img/lawlex-recent-search-icon.svg";
  import lawlexUserIcon from "@/img/lawlex-user-icon.svg";
  import { LAWLEXAU, LAWLEXEU, LAWLEXUS } from "../../constant";

  const { mapActions, mapGetters } = createNamespacedHelpers('quickviews');
  const LAWLEX_TITLES = {
    RECENT_SEARCHES: 'home_legislation_lawlexau_recent_search',
    US_SAVED_SEARCHES: 'home_legislation_lawlexus_saved_search',
    EU_SAVED_SEARCHES: 'home_legislation_lawlexeu_saved_search',
  };

  export default {
    name: "LawlexAccordion",
    components: {
        UserNotRegistered,
        NoAccess,
        SomethingWentWrong,
        NoDataOrUserNotActive
    },
    props: {
      content: { type: Object, required: true },
    },
    data() {
      return {
        lawlexNoDataIcon,
        lawlexUserIcon,
      };
    },
    computed: {
      ...mapGetters([
        'getLawlexRecentSearches',
        'getLawlexUsSavedSearches',
        'getLawlexLoadingStatus',
        'getEurlexSavedSearches',
      ]),
      accordionData() {
        if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
          return this.getLawlexRecentSearches.data;
        } else if (this.content.title === LAWLEX_TITLES.US_SAVED_SEARCHES) {
          return this.getLawlexUsSavedSearches.data;
        } else if (this.content.title === LAWLEX_TITLES.EU_SAVED_SEARCHES) {
          return this.getEurlexSavedSearches.data;
        }
        return [];
      },
      seeMoreUrl() {
        if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
        return this.getLawlexRecentSearches.seeMoreLink || '';
        } else if (this.content.title === LAWLEX_TITLES.US_SAVED_SEARCHES) {
        return this.getLawlexUsSavedSearches.seeMoreLink || '';
        } else if (this.content.title === LAWLEX_TITLES.EU_SAVED_SEARCHES) {
        return this.getEurlexSavedSearches.seeMoreLink || '';
        }
        return '';
      },
      hasErrorCode() {
        if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
            return this.getLawlexRecentSearches?.errorCode == 1;
        } else if (this.content.title === LAWLEX_TITLES.US_SAVED_SEARCHES) {
            return this.getLawlexUsSavedSearches?.errorCode == 1;
        } else if (this.content.title === LAWLEX_TITLES.EU_SAVED_SEARCHES) {
            return this.getEurlexSavedSearches?.errorCode == 1;
        }
        return false;
      },
      hasErrorCodeUserNotActive() {
        if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
            return this.getLawlexRecentSearches?.errorCode == 3;
        }
        return false;
      },
      hasErrorCodeTypeOtherErrors() {
        if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
          return this.getLawlexRecentSearches?.errorCode == 2;
        }
        return false;
      },
      noAccessCondition() {
        const isRecentSearchesBlocked = this.content.title === LAWLEX_TITLES.RECENT_SEARCHES &&
          this.getLawlexRecentSearches?.hasRecentSearch === false;

        const isUsSavedSearchBlocked = this.content.title === LAWLEX_TITLES.US_SAVED_SEARCHES &&
          this.getLawlexUsSavedSearches?.hasLawlexUSSavedSearch === false;

        const isSavedSearchBlocked = this.content.title === LAWLEX_TITLES.EU_SAVED_SEARCHES &&
          this.getEurlexSavedSearches?.hasLawlexEUSavedSearch === false;

        return isRecentSearchesBlocked || isUsSavedSearchBlocked || isSavedSearchBlocked;

      },
      lawlexTitles() {
        return LAWLEX_TITLES;
      },
      lawlexNoDataMessages() {
        return {
          RECENT_SEARCHES: this.$t('home_leg_recent_search_no_data'),
          US_SAVED_SEARCHES: this.$t('home_legislation_lawlexus_no_data'),
          EU_SAVED_SEARCHES: this.$t('home_legislation_lawlexeu_no_data'),
        };
      },
      noDataMessage() {
        const messages = this.lawlexNoDataMessages;
        const title = this.content.title;

        if (title === this.lawlexTitles.RECENT_SEARCHES) {
          return messages.RECENT_SEARCHES;
        } else if (title === this.lawlexTitles.US_SAVED_SEARCHES) {
          return messages.US_SAVED_SEARCHES;
        } else if (title === this.lawlexTitles.EU_SAVED_SEARCHES) {
          return messages.EU_SAVED_SEARCHES;
        }

        return '';
      },
      accessType() {
        switch (this.content.title) {
          case this.lawlexTitles.RECENT_SEARCHES:
            return 'recent_search';
          case this.lawlexTitles.US_SAVED_SEARCHES:
            return 'saved_search_us';
          case this.lawlexTitles.EU_SAVED_SEARCHES:
            return 'saved_search';
          default:
            return 'regulatory';
        }
      }
    },
    methods: {
      ...mapActions([
        'fetchLawlexAccordions',
        'redirectToUrl'
      ]),
      getLimitedContent(title, content) {
        if (
          [LAWLEX_TITLES.RECENT_SEARCHES, LAWLEX_TITLES.US_SAVED_SEARCHES, LAWLEX_TITLES.EU_SAVED_SEARCHES].includes(title) &&
            content.length > 7
        ) {
            return content.slice(0, 7).concat([{}]);
        }
            return content;
        },
        truncateEnd(str, maxLength = 35) {
          if (!str || str.length <= maxLength) return str;
          return str.slice(0, maxLength - 3) + '...';
        },
        clickUrl(url) {
            if (!url) {
              console.error("No URL provided for this item.");
              return;
            }
            const module = `Dashboard - ${this.$t(this.content.title)}`;
            const type = this.content.title === LAWLEX_TITLES.EU_SAVED_SEARCHES
              ? LAWLEXEU
              : this.content.title === LAWLEX_TITLES.US_SAVED_SEARCHES
              ? LAWLEXUS
              : LAWLEXAU;
            this.redirectToUrl({ url, module, type });
        },
        getImageSrc() {
          if (this.content.title === this.lawlexTitles.RECENT_SEARCHES) {
            return lawlexRecentSearchIcon;
          } else if (this.content.title === this.lawlexTitles.US_SAVED_SEARCHES) {
            return eurlexSavedSearchIcon;
          } else if (this.content.title === this.lawlexTitles.EU_SAVED_SEARCHES) {
            return eurlexSavedSearchIcon;
          }
        },
    },
    mounted() {
      let fetchType = '';
      if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
        fetchType = 'recentSearches';
      } else if (this.content.title === LAWLEX_TITLES.US_SAVED_SEARCHES) {
        fetchType = 'savedSearchesUs';
      } else if (this.content.title === LAWLEX_TITLES.EU_SAVED_SEARCHES) {
        fetchType = 'savedSearches';
      }
      this.fetchLawlexAccordions({ fetchType });
    },
  };
  </script>
